import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import FileSaver from 'file-saver';
import { useApi2fetch } from 'containers/Api2/index.js';
import IconButton from 'components/interaction/IconButton/index.jsx';
import toCSV from 'utils/toCSV.js';
import messages from './messages.js';

const csvDefinition = [
  { title: messages.firstName, getValue: (o) => o.firstName },
  { title: messages.lastName, getValue: (o) => o.lastName },
  { title: messages.children, getValue: (o) => o.connections.map((c) => c.accountName).join(', ') },
  { title: messages.email, getValue: (o) => o.email },
  { title: messages.phoneNumber, getValue: (o) => o.phone },
  { title: messages.address, getValue: (o) => o.address },
];

function ExportUsers(props) {
  const { roleType, groupId, filename = 'export.csv', ...rest } = props;
  const api2fetch = useApi2fetch();
  const intl = useIntl();
  const def = csvDefinition.map((o) => ({ ...o, title: intl.formatMessage(o.title) }));
  function handleClick() {
    api2fetch({ method: 'POST', url: 'sa/users/export', version: 2, body: { roleType, groupId }, noParse: true })
      .then((data) => {
        const csv = toCSV(data, def);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        FileSaver.saveAs(blob, filename);
      });
  }
  return (
    <IconButton variant="light" icon="ss-export lower-1 fs-3" onClick={handleClick} {...rest}>
      <FormattedMessage {...messages.export} />
    </IconButton>
  );
}

ExportUsers.propTypes = {
  roleType: PropTypes.number.isRequired,
  groupId: PropTypes.number,
  filename: PropTypes.string,
};

export default ExportUsers;
